export default __webpack_public_path__ + "static/media/metamask.970c70c2.svg";